import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-roll-uninti-grid',
  templateUrl: './time-roll-uninti-grid.component.html',
  styleUrls: ['./time-roll-uninti-grid.component.css']
})
export class TimeRollUnintiGridComponent implements OnInit {
  title = "view Time Roll (Unintigrated)";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Attendance-Leaves/time-roll-unintigrated/time-roll-uninti-grid/time-roll-uninti-grid.component.ts